'use client';

import { AppContextProvider } from '@/components/App';
import NetworkErrorToast from '@/components/network-error-toast';
import ToastContainer from '@/components/ToastContainer';
import StoreConfig from '@/config';
import { siteConfigIds } from '@/constants/site-config-ids';
import { MiniCartInfoProvider } from '@/context/mini-cart';
import { useAdapter } from '@/hooks/Adapter/useAdapter';
import { ApolloProvider } from '@apollo/client';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import SyncCartWrapper from '../sync-cart-wrapper';
import { SearchParamsRecorder } from './search-params-recorder';
import SyncUserInfo from './sync-user-info';
import { useGA4 } from './use-ga4';
import { useGTM } from './use-gtm';

const GlobalRemindDialogLazyLoad = dynamic(() => import('@/components/global-remind-dialog-lazy-load'), { ssr: false });
const GlobalBackToTop = dynamic(() => import('@/components/global-back-to-top'), { ssr: false });
const ServerNavigateLoading = dynamic(() => import('@/components/server-navigate-loading'), { ssr: false });
// const EasterEgg = dynamic(() => import('../easter-egg-2026'), { ssr: false });
// const ShapeDressRecommendation = dynamic(() => import('../shape-dress-recommendation'), { ssr: false });

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (str, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }

    // If a string
    return this.replace(new RegExp(str, 'g'), newStr);
  };
}

const Adapter = props => {
  const { children } = props;

  const { apolloProps, reduxProps } = useAdapter();

  const pathname = usePathname();

  useGTM({ id: siteConfigIds.gtmId });

  useGA4();

  useEffect(() => {
    const historyState = window.history.state;

    if (typeof historyState === 'object' && historyState !== null && historyState.isProductOption) return;

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  const isCustomizeDressPage = pathname === StoreConfig.customize_dress_url;

  return (
    <ApolloProvider {...apolloProps}>
      <ReduxProvider {...reduxProps}>
        <AppContextProvider>
          <MiniCartInfoProvider>
            <SyncUserInfo />
            <SyncCartWrapper>{children}</SyncCartWrapper>
            <ToastContainer />
            <NetworkErrorToast />
            {!isCustomizeDressPage && <GlobalBackToTop />}
            <ServerNavigateLoading />
            {/* <ShapeDressRecommendation /> */}
            {/* <EasterEgg /> */}
            <GlobalRemindDialogLazyLoad />
            <Suspense>
              <SearchParamsRecorder />
            </Suspense>
          </MiniCartInfoProvider>
        </AppContextProvider>
      </ReduxProvider>
    </ApolloProvider>
  );
};

export default Adapter;
